import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "TheHeader the-header" }
const _hoisted_2 = { class: "the-header__container page-container" }
const _hoisted_3 = { class: "the-header__logo" }
const _hoisted_4 = {
  key: 0,
  href: "/investments/primary-offerings",
  "aria-label": "AcreTrader Company Logo",
  class: "the-header__logo-absolute-link"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "the-header__navigation" }
const _hoisted_7 = {
  key: 0,
  class: "the-header__navigation-user-menu"
}

import {
  ref,
  onMounted,
  onBeforeUnmount,
  defineAsyncComponent,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useLogin, useNotificationDataAll, useUserNames } from 'Store';
import { scrollToTop } from 'Utils/view';
import { openModalLogin } from 'Components/ModalLogin';
import { ModalClosedByUserError } from 'Helpers/modal/ModalClosedByUserError';
import vOutsideClick from 'Helpers/directives/outside-click';
import BaseButtonToggleNav from 'Components/Base/BaseButtonToggleNav.vue';
import ControlRender from 'Components/ControlRender/ControlRender.vue';
import TheHeaderNav from './TheHeaderNav.vue';
import TheHeaderAuthButtons from './TheHeaderAuthButtons.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheHeader',
  props: {
    redirectOnLogin: {}
  },
  emits: ["popup-logged-in"],
  setup(__props: any, { emit: __emit }) {

const TheHeaderUserNav = defineAsyncComponent(
  () => import(/* webpackChunkName: 'TheHeaderUserNav' */ './TheHeaderUserNav.vue'),
);
const TheHeaderUserWelcome = defineAsyncComponent(
  () => import(/* webpackChunkName: 'TheHeaderUserWelcome' */ './TheHeaderUserWelcome.vue'),
);
const TheHeaderNotificationBell = defineAsyncComponent(
  () => import(/* webpackChunkName: 'TheHeaderNotificationBell' */ './TheHeaderNotificationBell.vue'),
);
const TheNavMobile = defineAsyncComponent(
  () => import(/* webpackChunkName: 'TheNavMobile' */ 'Components/TheNavMobile/TheNavMobile.vue'),
);
const TheNotificationsMenu = defineAsyncComponent(
  () => import(/* webpackChunkName: 'TheNotificationsMenu' */ 'Components/TheNotificationsMenu/TheNotificationsMenu.vue'),
);

const props = __props;
const emit = __emit;

const isNavbar = ref(false);
const isFixed = ref(false);
const isNotificationNavbar = ref(false);
const { isLoggedIn } = useLogin();
const { notificationAllNumberUnread, isSomeNotificationWithRedFlag } = useNotificationDataAll();
const { userFirstName, userFullName } = useUserNames();
const route = useRoute();
const router = useRouter();

function setIsFixedPosition() {
  const position = window.pageYOffset;
  isFixed.value = Boolean(position > 0);
}
function setNotificationOpenClose(val: boolean) {
  isNotificationNavbar.value = val;
}

function onLogoClick() {
  if (route.name !== 'home') return;
  scrollToTop();
}
function onNotificationsOutsideClick() {
  isNotificationNavbar.value = false;
}
function onNavMobileOutsideClick() {
  isNavbar.value = false;
}

function setQueryParamOnRequestLogin(redirect = props.redirectOnLogin) {
  const query = { ...route.query, redirect };
  // Add id as hash to url
  router.replace({ ...route, query });
}

async function removeQueryParamOnCloseLogin() {
  const query = { ...route.query };
  delete query.redirect;
  // Add id as hash to url
  await router.replace({ ...route, query });
}

async function loginByPopup() {
  try {
    if (props.redirectOnLogin) setQueryParamOnRequestLogin();
    await openModalLogin({}, false);
    if (props.redirectOnLogin) await removeQueryParamOnCloseLogin();
    emit('popup-logged-in');
  } catch (error) {
    if (error instanceof ModalClosedByUserError) await removeQueryParamOnCloseLogin();
    else throw error;
  }
}

onMounted(() => {
  window.addEventListener('scroll', setIsFixedPosition);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', setIsFixedPosition);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["the-header__wrap", { 'is--fixed': isFixed.value, 'is--open-mobile-menu': isNavbar.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(isLoggedIn))
            ? (_openBlock(), _createElementBlock("a", _hoisted_4))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "the-header__logo-absolute-link",
                to: { name: 'home' },
                "aria-label": "AcreTrader Company Logo",
                onClick: onLogoClick
              })),
          _createElementVNode("img", {
            src: require('images/logo-full.svg'),
            alt: "AcreTrader Company Logo",
            class: "the-header__logo-image",
            "aria-label": "AcreTrader Company Logo"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TheHeaderNav, { class: "the-header__menu" }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "the-header__vertical-line" }, null, -1)),
          (_unref(isLoggedIn))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(TheHeaderUserWelcome), { "user-name": _unref(userFirstName) }, null, 8, ["user-name"]),
                _createVNode(_unref(TheHeaderNotificationBell), {
                  "notification-unread-count": _unref(notificationAllNumberUnread),
                  "notification-red": _unref(isSomeNotificationWithRedFlag),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isNotificationNavbar.value = !isNotificationNavbar.value))
                }, null, 8, ["notification-unread-count", "notification-red"]),
                _createVNode(_unref(TheHeaderUserNav), { "user-name": _unref(userFullName) }, null, 8, ["user-name"])
              ]))
            : (_openBlock(), _createBlock(TheHeaderAuthButtons, {
                key: 1,
                onLoginClick: loginByPopup
              }))
        ]),
        _createVNode(BaseButtonToggleNav, {
          class: "the-header__toggle-button is--hidden-for-print",
          value: isNavbar.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isNavbar.value = !isNavbar.value))
        }, {
          default: _withCtx(() => [
            (_unref(isLoggedIn))
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["the-header__notifications", { 'is--red': _unref(isSomeNotificationWithRedFlag) }])
                }, null, 2)), [
                  [_vShow, _unref(notificationAllNumberUnread) > 0]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ], 2),
    _createVNode(ControlRender, {
      "when-true": isNavbar.value,
      timeout: 1000,
      "excluded-for-prerender": ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_unref(TheNavMobile), {
          value: isNavbar.value,
          onLoginClick: loginByPopup
        }, null, 8, ["value"]), [
          [_unref(vOutsideClick), {
          handler: onNavMobileOutsideClick,
          active: isNavbar.value,
          middleware: 'BaseButtonToggleNav toggle-button is--open the-header__toggle-button is--hidden-for-print',
        }]
        ])
      ]),
      _: 1
    }, 8, ["when-true"]),
    _createVNode(ControlRender, {
      "when-logged-in": "",
      "excluded-for-prerender": ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_unref(TheNotificationsMenu), {
          value: isNotificationNavbar.value,
          onCloseNotificationMenu: setNotificationOpenClose
        }, null, 8, ["value"]), [
          [_unref(vOutsideClick), { handler: onNotificationsOutsideClick, active: isNotificationNavbar.value }]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})